import { Action } from '@ngrx/store';
import { LoginMessage } from '@model';

export enum LoginMessagesActionTypes {
  LoadLoginMessages = '[Login messages] Load',
  LoadLoginMessagesSuccess = '[Login messages] Load success',
  LoadLoginMessagesFail = '[Login messages] Load fail'
}

export class LoadLoginMessages implements Action {
  readonly type = LoginMessagesActionTypes.LoadLoginMessages;
  constructor() {}
}

export class LoadLoginMessagesSuccess implements Action {
  readonly type = LoginMessagesActionTypes.LoadLoginMessagesSuccess;
  constructor(public payload: LoginMessage[]) {}
}

export class LoadLoginMessagesFail implements Action {
  readonly type = LoginMessagesActionTypes.LoadLoginMessagesFail;
  constructor(public payload: any) {}
}

export type LoginMessagesActions = LoadLoginMessages | LoadLoginMessagesSuccess | LoadLoginMessagesFail;
